// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__2F5Ou","bigColWidth":"Table_bigColWidth__3N_yh","biggerColWidth":"Table_biggerColWidth__3Woux","row":"Table_row__1jTAd","col":"Table_col__1MRfR"};